<template>
  <LoaderItem v-if="loading"></LoaderItem>

  <router-view v-slot="{ Component, route }" :key="$route.fullPath">
    <transition name="fade" mode="out-in" >
      <div :key="route.name">
        <component :is="Component"> </component>
      </div>
    </transition>
  </router-view>
  <ForceAlertPopup :the-alert="this.lastAlert" />

</template>

<script>
import LoaderItem from "@/components/partials/LoaderItem";
import EventBus from "@/common/EventBus";
import ForceAlertPopup from "@/components/alert/ForceAlertPopup";
import { Modal } from 'bootstrap'
import api from "@/services/api";
import TokenService from "@/services/auth/token.service";

export default {
  name: 'App',
  components: {ForceAlertPopup, LoaderItem,Modal},
  data() {
    return {
      loading: true,
      polling: null,
      showingAlert: false,
      lastAlertModal: false
    }
  },
  mounted() {
    this.pollData()
    this.lastAlertModal = new Modal(document.getElementById('forceAlertPopup'), {backdrop: 'static', keyboard: false})

    EventBus.on("logout", () => {

      this.logOut()
    })
    setTimeout(()=> this.loading = false, 300)

    //check if url is /login

    if(!window.location.pathname.includes('/login')) {
      api.post('auth/refresh').then(
          data => {
            TokenService.updateLocalAccessToken(data.data.access_token)
          }
      )
    }

  },
  beforeUnmount() {
    clearInterval(this.polling)
    EventBus.remove('logout')
  },

  methods: {
    logOut(){
      this.$store.dispatch('auth/logout')
      // this.$router.push('/login')
      document.location = '/login'
    },
    pollData () {
      if (this.$store.state.alert){
        this.showingAlert = false
        this.polling = setInterval(() => {
          this.$store.dispatch('alert/getLastAlert').then(
              () => {
                if (this.lastAlert){
                  this.showingAlert = true
                  this.$store.state.alert.showingLastAlertIcon = false
                  if (this.$store.state.alert.lastAlert && this.$store.state.alert.lastAlert.data.alert){
                    this.$store.state.alert.showingLastAlertIcon = true
                  }
                }
              }
          )
        }, 8000)
      }

    }
  },
  computed:{
    lastAlert(){
      if (this.$store.state.alert && this.$store.state.alert.lastAlert && this.$store.state.alert.lastAlert.data.alert && !this.showingAlert && this.lastAlertModal){
        this.lastAlertModal.show();
      }
      return this.$store.state.alert ? this.$store.state.alert.lastAlert : null
    }
  }

}
</script>

<style>
/*@import url('//fonts.cdnfonts.com/css/roboto');*/
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
@import url('https://fonts.cdnfonts.com/css/dejavu-sans');
@import url('https://fonts.cdnfonts.com/css/helvetica-2');


@font-face {
  font-family: "TBCDinMtavruli-Bold";
  src: url(../public/fonts/TBCDinMtavruli-Bold.eot);
  src: url(../public/fonts/TBCDinMtavruli-Bold.eot?#iefix) format("embedded-opentype"),
  url(../public/fonts/TBCDinMtavruli-Bold.ttf) format("truetype"),
  url(../public/fonts/TBCDinMtavruli-Bold.woff) format("woff");
  font-weight: 700;
  font-style: normal
}

@font-face {
  font-family: "TBCDinNusxuri-Bold";
  src: url(../public/fonts/TBCDinNusxuri-Bold.eot);
  src: url(../public/fonts/TBCDinNusxuri-Bold.eot?#iefix) format("embedded-opentype"),
  url(../public/fonts/TBCDinNusxuri-Bold.ttf) format("truetype"),
  url(../public/fonts/TBCDinNusxuri-Bold.woff) format("woff");
  font-weight: 700;
  font-style: normal
}

@font-face {
  font-family: "TBCDinNusxuri-Medium";
  src: url(../public/fonts/TBCDinNusxuri-Medium.eot);
  src: url(../public/fonts/TBCDinNusxuri-Medium.eot?#iefix) format("embedded-opentype"),
  url(../public/fonts/TBCDinNusxuri-Medium.woff) format("woff"),
  url(../public/fonts/TBCDinNusxuri-Medium.ttf) format("truetype");
  font-weight: normal;
  font-style: normal
}



:root {
  --gray-color:#e0e0e0;
  --main-bg: #0D1E41;
  --input-main-bg: #F3F7FE;
  --text-sub-color: #8B93A4;
  --text-sub-bold-color: #4b5779;
  --nav-text-color: #8593AD;
  --drop-shadow-color: rgba(112, 140, 176, .1);
  --border-color: #EAF0F8;
  --second-titles: #6B7A98;
  --hover-item: #F5F5F5;
  --toggle-background:#F7F9Fb;
  --brand-button-bg: #F8F9Fd;
  --green-circle:#6FCF97;
  --red-circle:#F47B7A;
  --search-bg:#F4F4F4;
  --dropzone-border:#DDE3EC;
  --dropzone-bg: #F8F9FB;
  --components-color:#85A4EB;
  --submit-button-bg:#46639E;
  --tab-bg:#F7F7F7;
  --wizard-circle-color:#6A96EF;
  --label-color:#313449;
  --input-color:#494E6E;
  --remove-border-color:#A5B4CB;
  --alert-red-color:#F04242;
}

select {
  color: var(--input-color);
}

.number-data{
  font-family: "Roboto", sans-serif !important;
}

.tab-content{
  height: 58vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.tab-content table thead tr {
  position: sticky;
  background-color: #ffffff;
  top: 0;
}

.v-select__slot {
  height: 28px !important;
}


.brand-text{
  color: var(--main-bg) !important;
}
.form-label{
  color: var(--label-color) !important;
  font-size: 14px;
}
.label-color{
  color: var(--label-color) !important;
  font-weight: bold;
  font-size: 16px;
}

.swal2-styled.swal2-confirm{
  background-color: var(--input-main-bg) !important;
  color: var(--text-sub-bold-color) !important;
}
.swal2-styled.swal2-default-outline:focus,.swal2-styled.swal2-confirm:focus{
  box-shadow:none!important;
  -webkit-box-shadow: none;
}

.vs__dropdown-menu{
  font-size: 14px;
  width: fit-content !important;
}


#range-daterange{
  font-size: 14px;
}
#alert-daterange{
  font-size: 14px;
}
#user-daterange{
  font-size: 14px;
}
#datetimerange-input1{
  font-size: 14px;
}
.form-control{
  font-size: 14px;
  color: var(--input-color);
}
.form-select{
	font-size: 14px;
	color: var(--input-color);
}
.additional-filter .form-control{
  height: 32.38px;
}

.vs__selected{
  color: var(--input-color) !important;
}
.vs__selected-options{
  font-size: 14px;
  padding-left: 10px !important;
}


.dropdown-height input{
  height:35.133px
}

#basic-addon2 ,#interval-name-start, #interval-name-end, #interval-name{
  height: 32.38px;
}
.input-group-text{
  font-size: 14px;
}

.input-group-text img{
  width:20px;
  height: 20px;
}

.no-padding{
  padding: 5px;
}

body{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#app {
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}

.fit-container{
  padding-left: 24px;
  padding-right: 22px;
}

.col-3{
  width: 24.2%;
}

.swal2-icon.swal2-warning{
  border-color: #F47B7A !important;
  color: #F47B7A !important;
}

.default-margin-top-content{
  margin-top: 30px;
}

.left_side{
  padding-top: 30px;
  height: 100vh;
  background: #FFFFFF;
  z-index: 8;
}

.right_side{
  font-family: "TBCDinNusxuri-Medium";
  padding-top: 30px;
  -webkit-box-shadow:0 16px 40px var(--drop-shadow-color);
  box-shadow: 0 16px 40px var(--drop-shadow-color);
  height: 100vh;
}


.content-side.left-side{
  /*height: 100vh;*/
}

.red-color{
  color: #dc3545;
}

.second-title{
  color: var(--second-titles);
}

.font-roboto{
  /*font-family: "Roboto", sans-serif;*/
  /*font-family: "Helvetica", sans-serif !important;*/
  font-family: var(--bs-body-font-family) !important;
}

.select-is-invalid > div {
  border-color: #dc3545 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(.375em + 1.3rem) center;
  background-size: calc(.75em + .375rem) calc(.75em + .375rem);
}

.select-is-invalid~.invalid-feedback {
  display: block;
}

.btn{
  font-size: 14px !important;
}

.btn-brand {
  background-color: var(--brand-button-bg);
  color: var(--second-titles);
  font-size: 16px;
  font-family: "TBCDinNusxuri-Medium";
}

.btn-brand:focus {
  outline: 0;
  box-shadow: none;
}

.btn-add{
  background-color: #F5F8FF;
  border-color: #85A4EB;
  color: #85A4EB;
  font-size: 16px;
  border-radius: 5px;
  font-family: "TBCDinNusxuri-Medium";

}

.btn-add:focus, .btn-add:hover{
  outline: 0;
  box-shadow: none;
  color: #85A4EB;
}

.btn-filter{
  background: #ffffff;
  border: 1px solid var(--dropzone-border);
}


.btn-primary{
  background-color: var(--submit-button-bg);
  border-color: transparent;
  color: #FFFFFF;
  font-size: 16px;
  border-radius: 5px;
  font-family: "TBCDinNusxuri-Medium";
}

.timerange-col .vs__dropdown-toggle{
  min-width:85px !important;
  max-width:85px;
}
.vs__clear{
  display: none;
}

.btn-primary:focus, .btn-primary:hover{
  outline: 0;
  box-shadow: none;
  color: #FFFFFF;
  border-color: transparent;
  background-color: var(--submit-button-bg);
}

.left_side_item{
  height: 90vh;
  font-family: "TBCDinNusxuri-Medium";
  color: var(--second-titles);
}

h6{
  color: var(--second-titles);
  font-size:16px;
}

.title-text{
  font-size: 16px;
  font-family: "TBCDinNusxuri-Bold";
  color: var(--main-bg);
}


.uppercased{
  font-family: "TBCDinMtavruli-Bold";
}

.btn{
  padding: .355rem .75rem !important;
}

.button-groups{
  /*padding-top:1.7%*/
  height:35.133px;
  margin-top:0.94rem;
}

.button-groups button:not(:first-child){
  margin-left: 10px;
}

.login_logo_wrapper{
  background: url("../public/img/tempohub_logo.png") no-repeat center center;
  background-size: contain;
  width: 209px;
  height: 47px;
  position: relative;
}
.login_logo_wrapper span{
  position:absolute;
  top: 70%;
  left: 85%;
  font-size: 12px;
}

.breadcrumb{
  padding-right: 10px !important;
  margin-top: 0.35%;
  color: var(--nav-text-color);
  margin-left: 10px;
  font-size: 24px;
  font-family: "TBCDinNusxuri-Medium";

}

.table thead tr th{
  border-bottom: 0;
}
.table thead tr th img{
  height: 20px;
}


.table thead tr td:hover, .table thead tr th:hover{
  cursor: pointer;
}

.table thead{
  font-size: 16px;
}

.table tbody{
  font-size: 14px;
}
.table thead{
  border-bottom:1px solid var(--dropzone-border) !important;
}

.breadcrumb ul{
  list-style-type: none;
  padding-left: 0 ;
}

.breadcrumb ul li{
  float: left;
}

.breadcrumb ul li a{
  color: var(--nav-text-color);
  text-decoration: none;
}

.breadcrumb .active-crumb{
  color: var(--text-sub-bold-color) !important;
}


.content-header{
  text-align: left;
  padding-top:20px;
}

.content-slots{
  margin-top: 20px;
  padding-left: 0;
  padding-right: 0;

}

.week-groups span.clicked{
  background-color: var(--submit-button-bg);
}

.week-groups{
  border:0;
  height: 100%;
}

.week-groups span{
  cursor: pointer;
  border: 0;
  color: var(--text-sub-bold-color);
}

.week-groups > .input-group-text{
  background: var(--search-bg) !important;
  padding-top:5px;
  padding-bottom:5px;
}


.timerange-col{
  width: 19%;
  margin-right: 0;
  padding-right: 0;
}

.addon-filter .form-control{
  padding-left: 4px;
}
.temp-input{
  width: 6.333% !important;
}
.temp-input-lg{
  width: 13.333% !important;
}

@media only screen and (min-width: 1801px) and (max-width: 1919px) {
  .timerange-col{
    width: 19.6% !important;
  }
}

@media only screen and (min-width: 1680px) and (max-width: 1800px) {
  .timerange-col{
    width: 21.1% !important;
  }

}


@media only screen and (min-width: 1198px) and (max-width: 1679px) {
  .timerange-col{
    width: 24.7% !important;
  }

  h6{
    font-size: 14px;
  }

  .table thead{
    font-size: 14px;
  }
  .table tbody{
    font-size: 12px;
  }

  .breadcrumb{
    margin-top: 5px;
    font-size: 14px;
  }
  .back-button{
    width: 25px;
  }

  #sensorReportingRange{
    font-size: 12px;
  }
  #datetimerange-input1{
    font-size:12px
  }
  #range-daterange{
    font-size: 12px;
  }
  #alert-daterange{
    font-size: 12px;
  }
  #user-daterange{
    font-size: 12px;
  }

  .vs__selected-options{
    font-size: 12px;
  }
  .v-select{
    height: 32px;
  }
  .vs__dropdown-menu{
    font-size: 12px;
  }
  .vs__search{
    font-size: 12px !important;
  }
  .dropdown-height input{
    height: 32.3833px;
  }
  .input-group-text:not(.input-group-text.exclude-this){
    height: 32.3833px;
  }
  .button-groups{
    height:32.3833px;
  }
  .tabs-component-tabs > .tabs-component-tab{
    padding: 5px 5px 5px 0 !important;
  }
  .tabs-component-tabs > .tabs-component-tab > .tabs-component-tab-a{
    font-size:14px !important;
  }

  .form-control{
    font-size: 12px;
  }
  .addon-filter .form-control{
    padding-left: 4px;
  }

  .input-group-text:not(.week-groups .input-group-text):not(.input-group-text.exclude-this){
    font-size:12px;
    padding: 1px;
  }
}

@media only screen and (min-width: 900px) and (max-width: 1197px) {
  .timerange-col{
    width: 39.3% !important;
  }
}

/*mobile style*/
@media only screen and (max-width: 799px)  {

  body{
    overflow-x:hidden !important;
    overflow-y: auto;
  }

  .connecting-line{
    top:0 !important;
  }

  .wizard-nav{
    margin-top:10px;
  }

  .wizard-nav ul li:first-child{
    margin-left: 0 !important;
  }

  .wizard-nav ul li:not(:first-child){
    margin-left:30px !important;
  }

  .wizard-nav .nav li a {
    width: 35px;
    height: 35px;
  }

  .wizard-nav .nav li a span{
    visibility: hidden;
  }

  .wizard-nav .nav li a .wizard-img-container{
    width: 40px;
    height: 40px;
  }

  .wizard-nav .nav li a .wizard-img-container img{
    width: 30px;
    height: 30px;
  }

  .active-tab .week-col .week-groups{
    margin-top:10px;
  }

  .active-tab .week-col .week-groups .input-group-text{
    padding:5px !important;
  }

  .navbar-toggler:focus{
    box-shadow:none !important;
  }

  .range-filter{
    left: 0;
  }
  .content-panel{
    margin-top:2.5% !important;
  }

  .additional-filter{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items:center;
  }
  .additional-filter .no-padding-div{
    margin-top: 7px;
    margin-bottom: 7px;
  }

  /*.additional-filter div{*/
  /*  margin-top:17px;*/
  /*  margin-bottom: 17px;*/
  /*}*/

  .temp-input-lg{
    width: 100% !important;
  }
  .temp-input{
    width: 100% !important;
  }

  .tabs-component-tabs{
    display: block !important;
  }

  .tabs-component-tabs > .tabs-component-tab{
    margin-left: 0 !important;
    height: auto !important;
    border-radius:0 !important;
  }
  .timerange-col{
    width: 100% !important;
    margin-top:17px;
    margin-bottom:17px;
  }

  .toolbar-area{
    position: absolute !important;
    right: 5%;
    top: 0;
    padding-top:.5rem;
    padding-bottom: .5rem;
  }
  .toolbar-area .navbar-nav{
    margin-bottom: 0 !important;
  }

  .header-panel.nav-alt{
    display: flex !important;
    justify-content: space-between !important;
    padding-bottom:10px;
  }

  .col-3.left_side{
    width: 36% !important;
  }
  .col-9.right_side{
    width: 62.5% !important;
    position:absolute;
    right: 0;
  }

  .col-9.right_side .navbar-toggler{
    margin-left: 0 !important;
  }
  .col-9.right_side nav  {
    top: 0;
    position:absolute;
  }

  .col-9.right_side nav #navbarSupportedContent{
    background: #FFFFFF;
    z-index: 99;
  }

  .opened-dropdown{
    display: block !important;
  }
  .col-12.d-flex{
    display:block !important;
  }
  .form-group{
    margin-left: 10px;
    margin-top:4px!important;
    margin-bottom:4px !important;
  }

  .col-9.right_side .navbar-toggler{
    margin-left: 50%;
  }
  .responsive-profile-bar{
    display: flex !important;
    align-content: center;
    align-items: center;
    justify-content: center !important;
    height: 56px;
  }

  .resp-flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
  }

  .responsive-sensor-container{
    display: block !important;
  }
  .responsive-sensor-container ul{
    padding-left: 0;
  }
  .responsive-sensor-container ul li{
    margin-top:10px;
    margin-bottom:10px;
    padding: 10px;
    list-style-type: none;
    border: 1px solid var(--border-color);
    border-radius: 5px;
  }
  .responsive-sensor-container ul li .each-responsive-sensor .sensor-data img{
    width:24px !important;
    height: 24px !important;
  }

  .toolbar-panel{
    flex-direction:column;
  }
  .action-buttons{
    padding-bottom: 10px;
  }
  .action-buttons img{
    width: 20px;
    height: 20px;
  }

  .button-switch{
    width: 100% !important;
    height: 45px !important;
    font-size: 18px !important;
    justify-content: space-around !important;
  }
  .button-switch img {
    width: 24px !important;
    height: 24px !important;
  }

  .col-9{
    width: 100% !important;
  }
  nav{
    font-size:16px !important;
  }

  h6{
    font-size: 14px;
  }

  .table thead{
    font-size: 14px;
  }
  .table tbody{
    font-size: 12px;
  }

  .breadcrumb{
    margin-top: 5px;
    font-size: 16px;
  }
  .back-button{
    width: 25px;
  }

  #sensorReportingRange{
    font-size: 12px;
  }
  #datetimerange-input1{
    font-size:12px
  }
  #range-daterange{
    font-size: 12px;
  }
  #alert-daterange{
    font-size: 12px;
  }
  #user-daterange{
    font-size: 12px;
  }

  .vs__selected-options{
    font-size: 12px;
  }
  .v-select{
    height: 32px;
  }
  .vs__dropdown-menu{
    font-size: 12px;
  }
  .vs__search{
    font-size: 12px !important;
  }
  .dropdown-height input{
    height: 32.3833px;
  }
  .input-group-text:not(.input-group-text.exclude-this){
    height: 32.3833px;
  }
  .button-groups{
    height:32.3833px;
    margin-top:5.5% !important;
  }
  .tabs-component-tabs > .tabs-component-tab{
    padding: 5px 5px 5px 0 !important;
  }
  .tabs-component-tabs > .tabs-component-tab > .tabs-component-tab-a{
    font-size:14px !important;
  }

  .form-control{
    font-size: 12px;
  }
  .addon-filter .form-control{
    padding-left: 4px;
  }

  .input-group-text:not(.week-groups .input-group-text):not(.input-group-text.exclude-this){
    font-size:12px;
    padding: 1px;
  }
}
/*end mobile style */

.p-10{
  padding: 10px;
}

.green-circle{
  margin-right: 10px;
  margin-left: 10px;
  padding:10px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
  background: var(--green-circle);
}

.red-circle{
  margin-right: 10px;
  margin-left: 10px;
  padding:10px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
  background: var(--red-circle);
}

.gray-circle{
  margin-right: 10px;
  margin-left: 10px;
  padding:10px;
  width: 15px;
  height: 15px;
  border-radius: 100px;
  background: var(--nav-text-color);
}

.alt-circle{
  padding: 5px;
  margin-top: 5px;
}

.btn-outline-secondary{
  border-color: var(--dropzone-border) !important;
  color: var(--second-titles);
}
.btn-outline-secondary:hover, .btn-outline-secondary:focus,  .btn-outline-secondary:active{
  background: transparent !important;
  color: var(--second-titles) !important;
  box-shadow: transparent !important;
}

hr{
  width: 70% !important;
  height: 1px;
  color: var(--border-color);
  border-color: var(--border-color);
  margin-top:5px;
  margin-bottom: 5px;
}

.leaflet-popup-content-wrapper{
  border-radius: 5px !important;
}
.leaflet-control-attribution.leaflet-control{
  display: none !important;
}


.tooltip-sensor-container{
  width: 240px;
  margin-left: -45px;
  margin-right: -45px;
  position: relative;
}

.tooltip-remove-sensor{
  position: absolute;
  right: 5%;
  top: -30px;
  background: white;
  border-radius: 100px;
  padding: 5px;
  border: 1px solid var(--remove-border-color)
}
.tooltip-remove-sensor:hover{
  cursor: pointer;
}

.tooltip-sensor-panel{

}

.tooltip-transmission{
  font-family: "roboto";
}


.header-panel{
  padding-top: 0.5%;
  padding-bottom: 0.5%;
  padding-right: 0;
  -webkit-box-shadow:0 16px 40px var(--drop-shadow-color);
  box-shadow: 0 16px 40px var(--drop-shadow-color);
}

.header-panel div nav .container-fluid{
  padding-right: 0;
}

.content-panel{
  margin-top:0.5%;
}

.content-side{
  background: #FFFFFF;
  -webkit-box-shadow:0 16px 40px var(--drop-shadow-color);
  box-shadow: 0 16px 40px var(--drop-shadow-color);
  border-radius: 5px;
}


.content-side .container{
  padding-left: 5px;
  padding-right: 5px;
}

.content{
  /*border:1px solid var(--border-color);*/
  border-radius: 7px;
  background: #FFFFFF;

}

.tabs-component-tabs > .tabs-component-tab > .tabs-component-tab-a{
  padding: 10px;
  text-decoration: none;
  font-family: "TBCDinNusxuri-Medium";
  font-size: 16px;
  color: var(--main-bg);
}

.Pagination{
  margin-top: 1% !important;
  padding-bottom:1% !important;

}

.hidden{
  visibility: hidden;
}
.visible{
  visibility: visible;
}

.no-bottom-border{
  border-bottom:0 !important;
}

.no-border{
  border: 0 !important;
}

.nav-alt .left_side, .nav-alt .right_side{
  padding-top: 0;
  height: auto;
}

.nav-alt .left_side{
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-alt .right_side{
  box-shadow: none !important;
}

.right_side .content{
  height: 80.3vh;
}

.right_side .content .content-body{
  height: 82%;
}
.v-select .vs__selected-options {
  flex-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


.vs__actions {
  margin-top: -10px;
}
.vs__actions button{
  margin-top:10px;
}

.vs__actions svg:nth-child(2){
  margin-top:14px;
}

.vs__actions svg:hover{
  cursor: pointer;
}

.vs__search{
  font-size: 14px !important;
}

.bread-area{
  margin-top:20px;
}

.pagination{
  margin-left: 1%;
}
.page-link{
  color: var(--label-color) !important;
}

/*transitions */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* route transitions */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.75s ease-out;
}

.slide-enter-to {
  position: absolute;
  right: 0;
}


.slide-enter-from {
  position: absolute;
  right: -100%;
}


.slide-leave-to {
  position: absolute;
  left: -100%;
}


.slide-leave-from {
  position: absolute;
  left: 0;
}

@media only screen and (max-width: 1367px) {
  .button-groups{
    margin-top:1.2%
  }
}

</style>
